<template>
  <div>
    <main role="main">

      <div class="container">

        <div class="row">
          <div class="col-md-12">
            <a class="mt-3 mb-3 d-block"
               @click="$router.replace({name: 'DocumentDetails', params: {id: nodeData.id}})">
              <i class="fa fa-chevron-circle-left"></i> {{ $t('text.globals.back') }}
            </a>
          </div>
        </div>

        <div class="row" v-if="Object.keys(nodeData).length > 0">

          <div class="col-md-12">

            <h2 class="preventLongStringOutbreak">
              <i :class="$globalFunctions.getFileTypeIcon(nodeData.content.mimeType)"></i>
              {{ nodeData.properties["cm:title"] }}
            </h2>
            <h6>
              <b>{{ $t('text.metadata.originalName') }}: {{
                  nodeData.properties["rma:origionalName"] ?
                      nodeData.properties["rma:origionalName"] : '/'
                }}</b>
            </h6>
            <p class="mb-3">
              <small><i class="fa fa-calendar text-black-50"></i>
                {{ moment(nodeData.modifiedAt).local().format("DD. MM. YYYY HH:mm:ss") }} <span
                    class="text-black-50">|</span> <i class="fa fa-user text-black-50"></i>
                {{ nodeData.modifiedByUser.displayName }}</small>
            </p>
          </div>

        </div>

        <div class="row">

          <loading :active.sync="isLoading"
                   :can-cancel="false"
                   :is-full-page="false"></loading>


          <div class="col-md-8 mb-5">

            <div class="row" v-if="Object.keys(nodeData).length > 0">
              <div class="col-md-12 form-condensed">

                <div class="p-4 bg-light">
                  <h4>{{ $t('text.globals.documentInformation') }}</h4>


                  <div class="form-group" v-if="!editMode">
                    <label for="description">{{ $t('text.documentDetailsEdit.file') }}</label>
                    <input type="file" class="form-control" id="file"
                           aria-describedby="description"

                           @change="getFile"
                           ref="myFile"
                           name="description"
                    />
                  </div>

                  <div class="form-group">
                    <label for="title">{{ $t('text.metadata.title') }}</label>
                    <input type="text" class="form-control" id="title"
                           aria-describedby="title"
                           v-model="nodeData.properties['cm:title']"
                           name="title"
                           :class="{'is-invalid': errors.title}"
                    >
                    <div class="invalid-feedback"
                         v-if="errors.title">
                      {{ $t('text.documentDetailsEdit.errorMessages.titleFieldRequired') }}.
                    </div>
                  </div>


                  <div v-if="!editMode || (editMode && !nodeData.properties['EH:komponenta_povezave_na_dokumente'])">
                    <div class="form-group">
                      <label for="description">{{ $t('text.metadata.description') }}</label>
                      <textarea class="form-control" id="description"
                                aria-describedby="description"
                                v-model="nodeData.properties['cm:description']"
                                name="description"
                                :class="{'is-invalid': errors.description}"
                      ></textarea>
                      <div class="invalid-feedback"
                           v-if="errors.description">
                        {{ $t('text.documentDetailsEdit.errorMessages.descriptionFieldRequired') }}.
                      </div>
                    </div>


                    <div class="form-group">
                      <label for="author">{{ $t('text.metadata.author') }}</label>
                      <input type="text" class="form-control" id="author"
                             aria-describedby="author"
                             v-model="nodeData.properties['cm:author']"
                             name="author"
                             :class="{'is-invalid': errors.author}"
                      >
                      <div class="invalid-feedback"
                           v-if="errors.author">
                        {{ $t('text.documentDetailsEdit.errorMessages.authorFieldRequired') }}.
                      </div>
                    </div>

                  </div>


                  <div v-if="editMode">

                    <div class="form-group">
                      <label for="mimetype">{{ $t('text.metadata.mimetype') }}</label>
                      <input type="text" class="form-control" id="mimetype"
                             aria-describedby="mimetype"
                             :placeholder="nodeData.content.mimeType"
                             disabled
                      />
                    </div>

                    <div class="form-group">
                      <label for="size">{{ $t('text.metadata.fileSize') }}</label>
                      <input type="text" class="form-control" id="size"
                             aria-describedby="size"
                             :placeholder="nodeData.content.sizeInBytes | prettyBytes"
                             disabled
                      />
                    </div>


                    <div class="form-group">
                      <label for="createdAt"> {{ $t('text.metadata.createdAtTimestamp') }}</label>
                      <input
                          type="text"
                          class="form-control"
                          id="createdAt"
                          aria-describedby="createdAt"
                          :placeholder="moment(nodeData.createdAt).local().format('DD. MM. YYYY HH:mm:ss')"
                          disabled

                      />
                    </div>

                  </div>
                  <div v-else>
                    <div class="form-group">
                      <label for="mimetype2">{{ $t('text.metadata.mimetype') }}**</label>
                      <input type="text" class="form-control" id="mimetype2"
                             aria-describedby="mimetype2"
                             v-model="nodeData.content.mimeType"

                      />
                    </div>

                    <div class="form-group">
                      <label for="size2">{{ $t('text.metadata.fileSize') }}**</label>
                      <input type="text" class="form-control" id="size2"
                             aria-describedby="size2"
                             v-model="nodeData.content.sizeInBytes"

                      />
                    </div>


                    <div class="form-group">
                      <label for="createdAt">{{ $t('text.metadata.createdAtTimestamp') }}**</label>
                      <VueCtkDateTimePicker
                          :noLabel="true"
                          id="Datum in ura zajema enote gradiva"
                          format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                          formatted="DD.MM.YYYY, HH:mm"
                          v-model="nodeData.createdAt"
                          :locale="$t('text.globals.datePickerLocale')"
                          :button-now-translation="$t('text.globals.now')"
                      />
                    </div>
                  </div>

                  <div class="form-group" v-if="uploadNewFileVersionMode">
                    <label for="author">{{ $t('text.documentDetailsEdit.documentVersionType') }}</label>

                    <v-select class="form-control" :options="$t('text.globals.minorMajorOptions')"
                              v-model="versionType">
                      <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                    </v-select>
                  </div>

                </div>

                <hr/>


                <div
                    v-for="(aspect, index) in eHrambaAspectsDictionary" :key="index"
                    v-if="!uploadNewFileVersionMode && (!nodeData.properties['EH:komponenta_povezave_na_dokumente'] || (nodeData.properties['EH:komponenta_povezave_na_dokumente'] && aspect.name === 'EH:komponenta')) && aspect.title !== 'E-podpis' && aspect.name !== 'EH:verzioniranje' && aspect.name !== 'EH:verzija_type' && aspect.name !== 'EH:verzija' && aspect.name !== 'EH:porocilo' && aspect.name !== 'EH:pretvorjeno_gradivo' && aspect.name !== 'EH:pretvorba_za_dolgorocno_hrambo' && aspect.name !== 'EH:pretvorjeno_gradivo_assoc_aspect' && aspect.name !== 'EH:pretvorjeno_gradivo_type'">


                  <div class="p-4 bg-light">
                    <h4>{{ aspect.title }}</h4>

                    <div v-for="property in aspect.properties"
                         v-if="checkIfVisibleOnGui(property.name)"
                         :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'">

                      <input v-if="property.dataType === 'd:boolean'" type="checkbox"
                             class="form-check-input"
                             :id="property.name"
                             v-model="nodeData.properties[property.name]"
                             :disabled="editMode === true && checkIfReadonly(property.name)"
                      >

                      <label :for="property.name">{{ property.title }}<span
                          v-if="editMode === false && markedFieldsAddMode.includes(property.name)">**</span><small
                          class="text-black-50">(typ:
                        {{ property.dataType }}, id: <i class="fa fa-info"
                                                        :title="property.name"></i>)</small></label>

                      <div v-if="checkIfCodeList(property.name)">

                        <div v-if="property.name === 'EH:rok_hrambe'">


                          <v-select
                              class="form-control"
                              v-model="nodeData.properties[property.name]"
                              :id="property.name"
                              :name="property.name"
                              :options="getCodeListOptions(property.name)"
                              label="explanation"
                              :reduce="item => item.id"
                              :disabled="editMode === true && checkIfReadonly(property.name)">
                            <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                          </v-select>

                        </div>
                        <div v-else>

                          <v-select
                              class="form-control"
                              v-model="nodeData.properties[property.name]"
                              :id="property.name"
                              :name="property.name"
                              :options="getCodeListOptions(property.name)"
                              label="description"
                              :getOptionLabel="item => item.description"
                              :reduce="item => item.id"
                              :disabled="editMode === true && checkIfReadonly(property.name)">
                            <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                          </v-select>

                        </div>

                      </div>
                      <div v-else>


                        <input
                            v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name !== 'EH:klasifikacijska_oznaka_razreda'"
                            type="text" class="form-control" :id="property.name"
                            v-model="nodeData.properties[property.name]"
                            :disabled="editMode === true && checkIfReadonly(property.name)"
                        >

                        <!-- klasifikacijska oznaka razreda-->
<!--                        <input-->
<!--                            v-if="property.dataType === 'd:text' && property.name === 'EH:klasifikacijska_oznaka_razreda'"-->
<!--                            type="text" class="form-control" :id="property.name"-->
<!--                            v-model="nodeData.properties[property.name]"-->
<!--                            :disabled="editMode === true && checkIfReadonly(property.name)"-->
<!--                            @input="allowOnlyNumbers(property.name)"-->
<!--                        />-->
                        <ClassificationClassDropdown
                            v-if="property.dataType === 'd:text' && property.name === 'EH:klasifikacijska_oznaka_razreda'"
                            :placeholder="$t('text.globals.enterValue')"
                            :id="property.name"
                            :isDisabled="editMode === true && checkIfReadonly(property.name)"
                            :value="nodeData.properties[property.name]"
                            @knSelected="(val) => { nodeData.properties[property.name] = val; $forceUpdate;  }"></ClassificationClassDropdown>


                        <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                               type="number"
                               class="form-control" :id="property.name"
                               v-model="nodeData.properties[property.name]"
                               :disabled="editMode === true && checkIfReadonly(property.name)"

                        >


                        <div v-if="property.dataType == 'd:datetime'">
                          <div v-if="editMode === true && checkIfReadonly(property.name)">
                            <input
                                type="text"
                                class="form-control"
                                :id="property.name"
                                :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).local().format('DD. MM. YYYY HH:mm:ss') : ''"
                                disabled
                            />
                          </div>
                          <div v-else>
                            <VueCtkDateTimePicker
                                :noLabel="true"
                                :id="property.name"
                                format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                formatted="DD.MM.YYYY, HH:mm"
                                v-model="nodeData.properties[property.name]"
                                :locale="$t('text.globals.datePickerLocale')"
                                :button-now-translation="$t('text.globals.now')"
                            />
                          </div>
                        </div>


                        <div v-if="property.dataType == 'd:date'">
                          <div v-if="editMode === true && checkIfReadonly(property.name)">
                            <input
                                type="text"
                                class="form-control"
                                :id="property.name"
                                :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).local().format('DD. MM. YYYY') : ''"
                                disabled

                            />
                          </div>
                          <div v-else>
                            <VueCtkDateTimePicker
                                :noLabel="true"
                                :id="property.name"
                                format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                formatted="DD.MM.YYYY, HH:mm"
                                :onlyDate="true"
                                v-model="nodeData.properties[property.name]"
                                :locale="$t('text.globals.datePickerLocale')"
                                :button-now-translation="$t('text.globals.now')"

                            />
                          </div>
                        </div>

                      </div><!-- end of else -->

                      <small class="text-danger"
                             v-if="$v.nodeData.properties[property.name] && $v.nodeData.properties[property.name].$error">
                        <span
                            v-if="$v.nodeData.properties[property.name].hasOwnProperty('required') && !$v.nodeData.properties[property.name].required">{{
                            $t('text.documentDetailsEdit.fieldShouldNotBeEmpty')
                          }}.</span>
                        <span
                            v-if="$v.nodeData.properties[property.name].hasOwnProperty('numeric') && !$v.nodeData.properties[property.name].numeric">{{
                            $t('text.documentDetailsEdit.valueMustBeNumeric')
                          }}.</span>
                      </small>

                    </div>

                  </div>

                  <hr/>

                </div>


                <div class="row">
                  <div class="col-md-12 mt-3">

                    <button class="btn btn-secondary"
                            @click="$router.replace({name: 'DocumentDetails', params: {id: nodeData.id}})">
                      {{ $t('text.globals.discardChanges') }}
                    </button>

                    <b-button id="uploadNewFileVersionButton1" class="float-right mr-0"
                              variant="primary" @click="save"><i
                        class="fas fa-save"></i>

                      <span v-if="uploadNewFileVersionMode">
                                                  {{ $t('text.documentDetailsEdit.uploadNewDocumentVersion') }}
                                            </span>
                      <span v-else>
                                                  {{ $t('text.globals.saveChanges') }}
                                            </span>
                    </b-button>
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="col-md-4 mb-5">
            <div class="row">
              <div v-if="editMode && Object.keys(nodeData).length > 0">
                <div class="col-md-12" v-if="$globalFunctions.checkForPermission('TISKANJE_ENOT')">
                  <div class="">
                    <a class="btn btn-success text-white d-block" @click="downloadFile()"><i
                        class="fa fa-download"></i> {{ $t('text.documentDetailsEdit.downloadFile') }}</a>
                  </div>
                </div>

                <div class="col-md-12 metadataSidebar">
                  <div class="mt-3 p-2 bg-light">
                    <div class="row mb-3">

                      <loading :active.sync="isLoadingPreview"
                               :can-cancel="false"
                               :is-full-page="false"></loading>

                      <div class="col-md-12">
                        <h5 class="mt-1">{{ $t('text.documentDetailsEdit.documentPreview') }}</h5>
                      </div>
                      <div class="col-md-12">

                        <div v-if="getPreviewIframeContent">

                          {{ $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) }}

                          <div class="card-body bg-light"
                               style="max-height: 455px; overflow-y: auto; padding-top: 20px; padding-bottom: 20px;"
                               v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'image' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'video' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'audio' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'html'">
                            <pdf
                                v-for="i in numPages"
                                :key="i"
                                :src="getPreviewIframeContent"
                                :page="i"
                                style="width: 100%; height: 100%; margin-bottom: 10px"
                            ></pdf>
                          </div>

                          <div class="card-body bg-light"
                               style="max-height: 430px; overflow-y: auto;"
                               v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) == 'video' || $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'audio'">
                            <iframe v-if="getPreviewIframeContent"
                                    :src="getPreviewIframeContent"
                                    frameborder="0"
                                    width="100%" height="1100" allowfullscreen
                                    webkitallowfullscreen></iframe>
                          </div>

                          <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                               v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'html'">
                            <iframe :src="getPreviewIframeContent" frameborder="0"
                                    width="100%" height="1100" allowfullscreen webkitallowfullscreen></iframe>
                          </div>

                          <div class="card-body bg-light"
                               style="max-height: 430px; overflow-y: auto;"
                               v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'image'">
                            <img :src="getPreviewIframeContent" class="img-responsive"
                                 style="width: auto; max-width: 100%;"/>
                          </div>

                        </div>


                        <div v-else class="alert alert-info mt-3">
                          <em><i class="fa fa-exclamation-triangle"></i>
                            {{ $t('text.globals.documentPreviewNotAvailable') }}</em>
                        </div>

                      </div>


                    </div>
                  </div>

                </div>


              </div>
            </div>
          </div>


        </div>
      </div>

    </main>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import SidebarNavigation from '../components/SidebarNavigation';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {required, minLength, between, email, numeric} from 'vuelidate/lib/validators'
import pdf from 'vue-pdf'
import ClassificationClassDropdown from '@/components/ClassificationClassDropdown'

export default {
  name: 'DocumentDetailsEdit',
  components: {
    ClassificationClassDropdown,
    SidebarNavigation,
    Loading,
    vSelect,
    pdf
  },

  data() {
    return {
      fileId: this.$route.params.id,
      page: 1,
      numPages: 0,
      rotate: 0,
      savedKlasifikacijskiRazred: null,
      uploadNewFileVersionMode: this.$route.params.uploadNewFileVersionMode,
      editMode: false,
      sites: [],
      allMetadataOptions: this.$store.getters.getAllMetadataOptions,
      user: {},
      error: '',
      testPolje: '',
      sampleNodeData: {
        isFile: true,
        createdByUser: {
          id: 'admin',
          displayName: 'Administrator'
        },
        modifiedAt: '2019-09-30T14:26:34.120+0000',
        nodeType: 'cm:content',
        content: {
          mimeType: 'application/msword',
          mimeTypeName: 'Microsoft Word',
          sizeInBytes: 73728,
          encoding: 'UTF-8'
        },
        parentId: '91c37ddf-95c2-4973-82bd-c195ab25a660',
        aspectNames: [
          'cm:versionable',
          'rmc:rmarecordCustomProperties',
          'EH:osnovni_podatki',
          'rma:recordComponentIdentifier',
          'rma:commonRecordDetails',
          'cm:ownable',
          'cm:titled',
          'rma:filePlanComponent',
          'cm:auditable',
          'rma:record',
          'EH:e_podpis',
          'EH:dodatni_podatki',
          'rn:renditioned',
          'EH:klasifikacija',
          'rma:dispositionLifecycle',
          'cm:taggable',
          'cm:thumbnailModification',
          'rma:recordOriginatingDetails',
          'EH:hramba',
          'rmc:customSupplementalMarkingList',
          'EH:oznaka_zadeve',
          'rma:recordSearch',
          'cm:author'
        ],
        createdAt: '2019-09-30T13:53:26.059+0000',
        isFolder: false,
        modifiedByUser: {
          id: 'admin',
          displayName: 'Administrator'
        },
        name: '',
        id: '7a495ca3-c34e-4dc9-a400-676381023cbf',
        properties: {
          "EH:fizicno_gradivo": false,
          "EH:lokacija_hrambe": "asd",
          "EH:opravilna_stevilka_zadeve": "aaaaaaa",
          "rma:recordSearchDispositionPeriodExpression": "0",
          "rma:recordSearchDispositionAuthority": "A - Arhivsko",
          "EH:datum_gradiva": "2019-09-30T00:00:00.000+0000",
          "rma:recordOriginatingCreationDate": "2019-09-30T13:55:02.937+0000",
          "rma:location": "Lokacija",
          "EH:cas_vnosa_podatka": "2019-09-30T14:00:00.000+0000",
          "EH:ime_in_priimek_podpisnika": "Izdajatelj",
          "EH:izdajatelj_certifikata": "asdasd",
          "EH:oznaka_vpisnika": "",
          "EH:kljucne_besede": "asdfasda, fdsgdfgdg, asfdasga",
          "rma:recordSearchDispositionEventsEligible": false,
          "EH:tip_gradiva": 1,
          "EH:povezave_na_vodilne_dokumente": "http://vm-alfresco-test-1.rettro.si",
          "EH:sodisce": "S23",
          "rma:identifier": "2019-1569851703025",
          "EH:vrsta_gradiva": 1,
          "EH:ID_gradiva": "ads",
          "EH:status_gradiva": 1,
          "rma:recordOriginatingLocation": "38745585-816a-403f-8005-0a55c0aec813",
          "cm:author": "Paul Hampton",
          "EH:velja_do": "2099-09-30T00:00:00.000+0000",
          "rma:recordOriginatingUserId": "admin",
          "rma:recordSearchDispositionInstructions": "Arhivsko gradivo",
          "EH:stevilka_certifikata": "asd",
          "EH:oznaka_da_je_podpis_veljaven_neveljaven": 1,
          "cm:versionType": "MAJOR",
          "cm:versionLabel": "1.0",
          "EH:posiljatelj_vloznik": "asdas",
          "rma:recordSearchHasDispositionSchedule": true,
          "cm:owner": {
            "id": "Lastnik",
            "displayName": "Lastnik"
          },
          "cm:lastThumbnailModification": [
            "doclib:1569851617420",
            "pdf:1569851642317"
          ],
          "rma:recordSearchDispositionPeriod": "none",
          "rma:recordSearchDispositionActionName": "retain",
          "rma:rootNodeRef": "84359128-8327-46c5-ad4e-b9f43330b1da",
          "EH:gradivo_e_podpisano": true,
          "cm:title": "pdf-test.pdf",
          "EH:stopnja_zaupnosti": 3,
          "EH:cas_preverjanja_elektronskega_podpisa": "2019-09-30T14:01:00.000+0000",
          "rma:dateFiled": "2019-09-30T13:56:01.640+0000",
          "EH:velja_od": "2019-09-30T00:00:00.000+0000",
          "EH:datum_in_ura_podpisa": "2019-09-30T14:00:00.000+0000",
          "rma:origionalName": "en_file.dot",
          "cm:description": "Opis opis opis",
          "EH:ID_zadeve": "aaaaaaa",
          "EH:oznaka_priloge_v_popisu_spisa": "aaaaaaabbbbbbbbcccccccc",
          "EH:casovni_zig": "2019-09-30T14:00:00.000+0000",
          "EH:naslovnik": "asd",
          "EH:klasifikacijska_oznaka_razreda": "10201",
          "EH:oznaka_povezanega_sistema": "EVIP"
        }
      },

      nodeData: {
        "isFile": true,
        "createdByUser": {
          "id": "",
          "displayName": ""
        },
        "modifiedAt": "",
        "nodeType": "cm:content",
        "content": {
          "mimeType": "",
          "mimeTypeName": "",
          "sizeInBytes": 0,
          "encoding": "UTF-8"
        },
        "parentId": "",
        "aspectNames": [
          "cm:versionable",
          "rmc:rmarecordCustomProperties",
          "EH:osnovni_podatki",
          "rma:recordComponentIdentifier",
          "rma:commonRecordDetails",
          "cm:ownable",
          "cm:titled",
          "rma:filePlanComponent",
          "cm:auditable",
          "rma:record",
          "EH:e_podpis",
          "EH:dodatni_podatki",
          "rn:renditioned",
          "EH:klasifikacija",
          "cm:taggable",
          "rma:dispositionLifecycle",
          "cm:thumbnailModification",
          "rma:recordOriginatingDetails",
          "EH:hramba",
          "rmc:customSupplementalMarkingList",
          "EH:oznaka_zadeve",
          "cm:author",
          "rma:recordSearch"
        ],
        "createdAt": "",
        "isFolder": false,
        modifiedByUser: {
          "id": "",
          displayName: ""
        },
        "name": "",
        "id": "",
        "properties": {},
        types: []
      },
      isLoading: true,
      isLoadingPreview: true,
      renditionRequests: 0,
      fileBlob: null,
      filePreviewBlob: null,
      file: null,
      alfrescoDictionary: null,
      eHrambaAspectsDictionary: null,
      versionType: null,
      disabledFieldsEditMode: [
        'EH:format_gradiva_preverjen',
        'EH:format_datum_preverbe',
        'EH:koncni_format',
        'EH:format_ustrezen',
        'EH:po_za_konverzijo',
        'EH:izvorna_oblika',
        'EH:rok_hrambe',
        'EH:datum_zacetka_teka_roka_hrambe',
        'EH:datum_izteka_roka_hrambe',
        'EH:oblika_gradiva_po_PETZ',
        'EH:datum_zadnje_spremembe_statusa_gradiva',
        'EH:mesto_hrambe',
        'EH:status_pretvorbe_v_obliko_za_dolgotrajno_hrambo',
        'EH:klasifikacijska_oznaka_razreda',
        'EH:ID_zadeve',
        'EH:oznaka_vpisnika',
        'EH:oznaka_povezanega_sistema',
        'EH:opravilna_stevilka_zadeve',
        'EH:sodisce',
        'EH:trajanje_roka_hrambe',
        'EH:tip_gradiva',
        'EH:povezave_na_vodilne_dokumente',
        'EH:komponenta_povezave_na_dokumente'
      ],

      markedFieldsAddMode: [
        'EH:rok_hrambe',
        'EH:datum_zacetka_teka_roka_hrambe',
        'EH:oblika_gradiva_po_PETZ',
        'EH:datum_zadnje_spremembe_statusa_gradiva',
        'EH:mesto_hrambe',
        'EH:format_gradiva_preverjen',
        'EH:format_datum_preverbe',
        'EH:koncni_format',
        'EH:format_ustrezen',
        'EH:po_za_konverzijo',
        'EH:izvorna_oblika',
        'EH:trajanje_roka_hrambe'
      ],

      visibleFiledsIfComponent: [],
      codeListProperties: []

    };
  },


  beforeCreate: function () {
    document.body.className = 'dashboard';
  },

  mounted() {

    const _this = this;

    console.log("MOUNTED");

    let p1 = _this.$store.dispatch("retrieveAlfrescoDictionary");
    let p2 = _this.$store.dispatch("retrieveCodeListProperties");


    Promise.all([p1, p2]).then((values) => {
      this.alfrescoDictionary = this.$store.getters.getAlfrescoDictionary;
      console.log("alfresco dictionary: ", this.alfrescoDictionary);

      this.eHrambaAspectsDictionary = this.$store.getters.geteHrambaAlfrescoDictionary;
      console.log("aspectsDictionary", this.eHrambaAspectsDictionary);

      this.codeListProperties = this.$store.getters.getCodeListProperties;
      console.log("codeListProperties", this.codeListProperties);

      if (this.fileId) {
        this.getNode(this.fileId);
        this.editMode = true;
      } else {
        this.editMode = false;
        this.isLoading = false;
      }

    });


  },

  computed: {
    getPreviewIframeContent() {
      const _this = this;

      if (_this.filePreviewBlob !== null) {

        console.log("HERE", _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType));
        if (_this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'image' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'video' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'audio' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'html') {
          pdf.createLoadingTask(window.URL.createObjectURL(_this.filePreviewBlob)).then(pdf => {
            _this.numPages = pdf.numPages;
          });
        }

        return window.URL.createObjectURL(_this.filePreviewBlob);
      }
    },

    getValidators() {
      const _this = this;
      let propertiesValidators = {};

      let types = [];

      if (this.alfrescoDictionary) {

        types = _.filter(_this.alfrescoDictionary, function (v, k) {
          if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0, 4) !== 'rma:') {
            return true
          } else {
            return false
          }
        });

        // types.push({
        //     name: 'name',
        //     required: true,
        //     dataType: 'd:long'
        // });

        console.log("types", types);

        for (let i = 0; i < types.length; i++) {

          _.forOwn(types[i].properties, function (v, k) {
            let rules = {};

            if (v.mandatory && v.dataType !== 'd:boolean') { // boolean field cannot be required
              // cannot be mandatory if listed in markedFieldsAddMode
              if (_this.markedFieldsAddMode.indexOf(v.name) < 0) {
                rules.required = required;
              }
            }

            if (v.dataType === 'd:long') {
              rules.numeric = numeric;
            }
            propertiesValidators[v.name] = _.forOwn(rules, function (_v, _k) {
              return _v
            });
          });

        }
      }

      return propertiesValidators;
    }
  },

  validations() {

    console.log("propertiesValidators", this.getValidators);

    return {
      nodeData: {
        "properties": this.getValidators
      }
    }
  },

  methods: {

    getFile() {
      const _this = this;


      _this.file = _this.$refs.myFile.files[0];
      console.log("this file: ", _this.file);

      _this.nodeData.name = _this.file.name;
      _this.nodeData.properties["cm:title"] = _this.file.name;
      _this.nodeData.content.mimeType = _this.file.type;
      _this.nodeData.content.sizeInBytes = _this.file.size;
      _this.filePreviewBlob = null;
      console.log(_this.file);
    },

    async getNode(nodeId) {
      const _this = this;

      await axios.get(config.alfrescoCoreApi + 'nodes/' + nodeId)
          .then((res) => {

            console.log(res);
            _this.nodeData = res.data.entry;

            _this.getFileBlob();

            _this.savedKlasifikacijskiRazred = _this.nodeData.properties["EH:klasifikacijska_oznaka_razreda"];

            _this.isLoading = false;
            console.log("nodeData: ", _this.nodeData);

            if (_this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'pdf' ||
                _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'image' ||
                _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'audio' ||
                _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'video' ||
                _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'html') {
              _this.showPreview(false);
              _this.isLoading = false;
            } else {
              _this.getFilePreview();
              _this.isLoading = false;
              _this.isLoadingPreview = true;
            }

          })
          .catch((error) => {
            console.error(error);

            _this.isLoading = false;
          });


    },

    getFileBlob() {
      const _this = this;

      this.isLoading = true;

      axios.get(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true', {
        method: 'GET',
        responseType: 'blob' //Force to receive data in a Blob Format
      })

          .then((res) => {

            console.log("RESPONSE ", res);


            this.fileBlob = res.data;
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);

            this.isLoading = false;
          });

    },

    getFilePreview() {
      const _this = this;

      axios.get(config.alfrescoThumbnails + '/' + _this.nodeData.id + '/content/thumbnails/pdf?c=force', {
        method: 'GET',
      })
          .then((res) => {
            console.log(res);
            _this.fileBlob = res.data;
            _this.showPreview(true);
          })
          .catch((error) => {
            console.error(error);
            _this.isLoadingPreview = false;

            Vue.$toast.open({
              message: this.$t('text.globals.documentPreviewNotAvailable'),
              type: 'error',
              position: 'top-right'
            });

          });
    },

    showPreview(showFromRenditions) {
      const _this = this;

      let getPdfPreview = "";

      if (showFromRenditions) {
        getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions/pdf/content?attachment=true&placeholder=false';
      } else {
        getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true';
      }


      axios.get(getPdfPreview, {
        method: 'GET',
        responseType: 'blob' //Force to receive data in a Blob Format
      })

          .then((res) => {
            console.log("RES", res.data);

            _this.filePreviewBlob = res.data;
            _this.isLoading = false;
            _this.isLoadingPreview = false;
          })
          .catch((error) => {
            console.error(error);

            _this.isLoading = false;
          });

    },

    downloadFile() {
      const _this = this;

      this.isLoading = true;

      const url = window.URL.createObjectURL(_this.blobToFile(_this.fileBlob, _this.nodeData.name));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', _this.nodeData.name);
      link.setAttribute('type', _this.nodeData.content.mimeType);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.isLoading = false;

    },

    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },

    save() {
      const _this = this;
      console.log("TODO - SAVE");

      _this.isLoading = true;

      _this.$v.nodeData.$touch();
      // console.log("_this.$v.nodeData", _this.$v.nodeData);

      //if(_this.$v.nodeData.$error) return;


      let data = _this.nodeData;

      if (this.uploadNewFileVersionMode) {
        data.versionType = this.versionType;
      }

      if (_this.editMode) {
        // UPDATE METADATA SCENARIO

        data = _.pick(data, ['name', 'properties']);

        console.log("data.properties", data);

        // filter data - only specific fields can be updated
        let propertiesForUpdate = [];

        _.forOwn(data.properties, function (v, k, tole) {
          // console.log("v",v);
          // console.log("k", k);
          // console.log("tole", tole);

          if (k.substring(0, 3) === 'EH:') {
            console.log(k);
            propertiesForUpdate.push(k);
            //delete data.properties[k]
          }
        });


        propertiesForUpdate.push('cm:description', 'cm:author', 'cm:title');
        console.log("propertiesForUpdate", propertiesForUpdate);

        data.properties = _.pick(data.properties, propertiesForUpdate);


        axios.put(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id, data)
            .then((res) => {
              //_this.getNode(_this.nodeData.id);
              _this.$router.replace({name: 'DocumentDetails', params: {id: _this.nodeData.id}});
              //_this.$router.go(-1);
            })
            .catch((error) => {
              console.error(error);
              this.isLoading = false;
            });


      } else {
        // TEST CLIENT SCENARIO (upload file + metadata)

        let types = _.filter(_this.$store.getters.getAlfrescoDictionary, function (v, k) {
          if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0, 4) !== 'rma:') {
            return true
          } else {
            return false
          }
        });

        data.types = types;


        // covert long and int string to int + remove null items
        _.each(data.properties, function (val, key) {
          _.forOwn(data.types, function (_val) {
            if (_val.properties[key] && (_val.properties[key].dataType === 'd:long' || _val.properties[key].dataType === 'd:int')) {
              if (val !== null && val !== '') {
                data.properties[key] = parseInt(val);
              } else if (val == '') {
                data.properties[key] = null;
              }
            }
          });


          // remove all items where value is null on empty string
          if (data.properties[key] === null || data.properties[key] === "") {
            delete data.properties[key]
          }
        });


        console.log("DATA", JSON.stringify(data));

        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("data", JSON.stringify(data));

        axios.post(config.demoVpisnik, formData)
            .then((res) => {


              _this.isLoading = false;

              Vue.$toast.open({
                message: this.$t('text.documentDetailsEdit.documentSuccessfullySent'),
                type: 'success',
                position: 'top-right'
              });

              // TODO (for sprint #4)
              if (this.uploadNewFileVersionMode) {

              }
              console.log(res);

            })
            .catch((error) => {
              console.error(error);


              _this.isLoading = false;
            });

      }


    },


    checkIfCodeList(propertyName) {
      const _this = this;
      let isCodeList = false;

      _.each(_this.allMetadataOptions, function (val, key) {
        let property = val.property;

        if (propertyName === property) {
          isCodeList = true;
          return false;
        }
      });

      return isCodeList;

    },

    getCodeListOptions(propertyName) {
      const _this = this;
      let options = [];

      _.each(_this.allMetadataOptions, function (val, key) {
        let property = val.property;

        if (propertyName === property) {
          //nodeData.properties[property] = _.find(allMetadataOptions[key].body, {id: nodeData.properties[property]}).description;
          if(property === 'EH:ciljni_povezan_sistem') {
            options = _.filter(val.body, { ehramba: true });
          } else {
            options = val.body;
          }

          return false;
        }
      });

      if (propertyName === 'EH:vrsta_gradiva') {
        options = _.filter(options, {active: true});
      }

      // fix for weird case where ids are converted to strings - e.g. "1"
      _.each(options, function(val,idx){
        if(parseInt(val.id) != NaN) {
          options[idx].id = parseInt(val.id);
        }
      });

      return options
    },

    cancel() {
      console.log("TODO - CANCEL");
      window.history.go(-1);
    },

    allowOnlyNumbers(fieldName) {
      const _this = this;

      let regex = /^[0-9]*$/;
      if (regex.test(_this.nodeData.properties[fieldName])) {
        _this.savedKlasifikacijskiRazred = _this.nodeData.properties[fieldName];
      } else {
        _this.nodeData.properties[fieldName] = _this.savedKlasifikacijskiRazred;
      }


    },

    checkIfReadonly(name) {
      const _this = this;
      let readOnly = false;

      _.map(_this.codeListProperties, function (item) {
        _.filter(item.properties, function (innerItem) {
          if (innerItem.name === name) {
            readOnly = innerItem.readOnly
          }
        });
      });


      return readOnly;
    },

    checkIfVisibleOnGui(name) {
      const _this = this;
      let visibleOnGui = false;

      _.map(_this.codeListProperties, function (item) {
        _.filter(item.properties, function (innerItem) {
          if (innerItem.name === name) {
            visibleOnGui = innerItem.showOnGui
          }
        });
      });

      return visibleOnGui;
    }

  }


};
</script>



// WEBPACK FOOTER //
// src/pages/DocumentDetailsEdit.vue